module.exports = __webpack_public_path__ + "img/horizontal_4_1_r_8023.26873917.png";